// extracted by mini-css-extract-plugin
var _1 = "WidgetListPipeline-moduleWidgetListPipeline__mkiHX";
export { _1 as "WidgetListPipeline" }
